var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3E5BA9",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    stroke: "#3E5BA9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.177,197.119c-1.975-6.079-7.23-10.51-13.554-11.429l-156.54-22.758L271.059,21.066 c-2.829-5.731-8.667-9.359-15.059-9.359c-6.391,0-12.23,3.628-15.059,9.359l-70.024,141.866L14.377,185.689 c-6.324,0.919-11.58,5.35-13.554,11.429c-1.976,6.079-0.328,12.753,4.25,17.214L118.338,324.74L91.619,480.664 c-1.08,6.3,1.51,12.665,6.681,16.422c5.17,3.756,12.024,4.252,17.683,1.279l140.016-73.593l140.014,73.593 c5.688,2.99,12.54,2.457,17.683-1.279c5.171-3.756,7.762-10.123,6.681-16.422L393.66,324.741l113.267-110.409 C511.505,209.87,513.153,203.196,511.177,197.119z M363.897,306.851c-3.958,3.857-5.763,9.414-4.83,14.861l22.463,131.097 l-117.718-61.875c-4.89-2.572-10.735-2.573-15.625,0l-117.719,61.875l22.463-131.097c0.934-5.446-0.872-11.004-4.83-14.861 L52.878,214.03l131.607-19.133c5.469-0.795,10.195-4.23,12.643-9.185L256,66.439l58.872,119.274 c2.447,4.955,7.174,8.39,12.643,9.185l131.607,19.133L363.897,306.851z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteEmpty);
export default __webpack_public_path__ + "static/media/favoriteEmpty.4ba3e8eb7e0deba4b71aee9ca09f4f83.svg";
export { ForwardRef as ReactComponent };